import React from 'react';

import { FormattedMessage } from 'react-intl';

import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import Link from '@atlaskit/link/link';
import { Inline, Text } from '@atlaskit/primitives/compiled';

import {
	MessageBannerGrid,
	type MessageBannerGridProps,
} from '../../../../common/ui/message-banner-grid';
import { messages } from './messages';

export const AssetsAppMessageBanner = ({ testId }: MessageBannerGridProps): React.JSX.Element => {
	return (
		<MessageBannerGrid testId={testId}>
			<StatusInformationIcon label="information" color="var(--ds-icon-brand)" />
			<Inline space="space.050" alignBlock="center" shouldWrap>
				<Text size="medium">
					<FormattedMessage
						{...messages.assetsAsAnAppBannerText}
						values={{
							assetsSearchLink: (children) => (
								<Link href="/jira/assets?showSearch=true">{children}</Link>
							),
							bold: (children) => <Text weight="bold">{children}</Text>,
						}}
					/>
				</Text>
			</Inline>
		</MessageBannerGrid>
	);
};
